import { createSlice } from '@reduxjs/toolkit';
import { AdapterIndexedDB } from './AdapterIndexedDB';
import { AdapterWebSocket } from './AdapterWebSocket';
import { AdapterConfigureGenerico } from './AdapterConfigureGenerico';
import { AdapterStorage } from './AdapterStorage';

const { autoInventario } = AdapterStorage.get('autoInventario')

interface SliceGenericoState {
	iconMenu: boolean;
	showSaludo: boolean;

	loading: boolean;
	textLoading: string;

	// websocket: AdapterWebSocket;

	// dbLocal: AdapterIndexedDB;

	online: boolean;
	countProcess: number;

	loadingMaestros: boolean;
	availableUpdate: boolean;
	dataStockPersonalTotal: Array<any>;

	autoInventario: boolean | null
};

const initialState: SliceGenericoState = {
	iconMenu: false,
	showSaludo: false,

	loading: false,
	textLoading: '',

	online: navigator.onLine,
	countProcess: 0,

	loadingMaestros: true,
	availableUpdate: false,
	dataStockPersonalTotal: [],
	autoInventario: autoInventario
};

// initialState.websocket.create();
// initialState.websocket.init();

// initialState.dbLocal.run();

const genericoSlice = createSlice({
	name: 'genericoSlice',
	initialState,
	reducers: {
		addLoading: (state, action) => {
			return {
				...state,
				loading: true,
				textLoading: action.payload.textLoading,
			};
		},
		removeLoading: state => {
			return {
				...state,
				loading: false,
				textLoading: '',
			};
		},
		showIconMenu: state => {
			return {
				...state,
				iconMenu: true,
			};
		},
		hideIconMenu: state => {
			return {
				...state,
				iconMenu: false,
			};
		},
		changeSaludo: (state, action) => {
			return {
				...state,
				showSaludo: action.payload,
			};
		},
		changeOnline: (state, action) => {
			return {
				...state,
				online: action.payload,
			};
		},
		changeCountProcess: (state, action) => {
			return {
				...state,
				countProcess: action.payload,
			};
		},
		changeAutoInventario: (state, action) => {
			AdapterStorage.set('autoInventario', action.payload)
			return {
				...state,
				autoInventario: action.payload,
			};
		},
		addCountProcess: (state) => {
			let count: number = state.countProcess;
			count += 1;
			return {
				...state,
				countProcess: count,
			};
		},
		removeLoadingMaestros: (state) => {
			return {
				...state,
				loadingMaestros: false
			};
		},
		changeAvailableUpdate: (state, action) => {
			return {
				...state,
				availableUpdate: action.payload,
			};
		},
		saveDataStockPersonalTotal: (state, action) => {
			return {
				...state,
				dataStockPersonalTotal: action.payload,
			};
		},
		deleteDataStockPersonalTotal: (state) => {
			return {
				...state,
				dataStockPersonalTotal: [],
			};
		},
	},
});


export const {
	showIconMenu,
	hideIconMenu,
	addLoading,
	removeLoading,
	changeSaludo,
	changeOnline,
	changeCountProcess,
	addCountProcess,
	removeLoadingMaestros,
	changeAvailableUpdate,
	saveDataStockPersonalTotal,
	deleteDataStockPersonalTotal,
	changeAutoInventario,
} = genericoSlice.actions;

export default genericoSlice.reducer;